export default "__VITE_ASSET__CsOqJ4gY__"